// app/javascript/controllers/load_more_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]

  connect() {
    console.log("load-more controller connected")
    this.loadingText = this.linkTarget.innerHTML

    document.documentElement .addEventListener("turbo:before-stream-render", async (event) => {
      console.log("turbo:before-stream-render")
      this.linkTarget.innerHTML = this.loadingText
    })
  }

  startLoading() {
    console.log("startLoading")
    this.linkTarget.innerText = "Loading..."
  }

  stopLoading() {
    console.log("stopLoading")
    this.linkTarget.innerHTML = this.loadingText
  }
}
